module.exports = __webpack_public_path__ + "static/media/kulogo.41cce3a8.png";